import { EntityType } from "@btnet/services-btnet/handlers/models/entityType";

export function arePlansLinkingSupportedForEntity(entityType: EntityType): boolean {
    switch (entityType) {
        case EntityType.BidPackage:
        case EntityType.PurchaseOrder:
        case EntityType.Rfi:
        case EntityType.Submittal:
        case EntityType.SelectionOptions:
            return true;
        default:
            return false;
    }
}
